import React from 'react';

interface ScrollableListProps {
  children: React.ReactNode;
  emptyMessage?: string;
  viewportHeightPercentage?: number;
  className?: string;
  hideScrollbar?: boolean;
  style?: React.CSSProperties;
}

export function ScrollableList({
  children,
  emptyMessage = 'No items to display',
  viewportHeightPercentage = 50,
  className = '',
  hideScrollbar = false,
  style,
}: ScrollableListProps) {
  const hasItems = React.Children.count(children) > 0;

  return (
    <div
      className={`d-flex flex-column flex-grow-1 overflow-auto w-100 ${className}`}
      style={{
        height: `${viewportHeightPercentage}vh`,
        ...(hideScrollbar
          ? {
              scrollbarWidth: 'none', // Firefox
              msOverflowStyle: 'none', // IE 10+
              overflow: 'auto',
            }
          : {}),
        ...style,
      }}
      {...(hideScrollbar && {
        // Chrome, Safari, Opera
        className: `d-flex flex-column flex-grow-1 overflow-auto w-100 ${className} hide-scrollbar`,
      })}
    >
      {!hasItems ? (
        <div className="text-center text-muted p-4 bg-neutral-800 rounded">
          {emptyMessage}
        </div>
      ) : (
        children
      )}
      <style>
        {hideScrollbar
          ? `
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `
          : ''}
      </style>
    </div>
  );
}
